import React from 'react';
import * as Styles from './BannerOfferPro.styles';
import withErrorBoundary from '@/utils/errorBoundary';
import GradientButton from '../GradientButton';
import useLocale from '@/hooks/useLocale';
import { useResize } from '@/hooks/useResize';

const BannerOfferPro = ({ isProPlan, handleShowModalGetPro }) => {
  const { studio: studioLocale } = useLocale();
  const windowRect = useResize();
  const { width } = windowRect;
  const mobile = width < 960;

  if (isProPlan) {
    return null;
  }

  return (
    <Styles.BannerOfferPro>
      <Styles.WrapperText>
        <Styles.Title>
          {studioLocale.bannerOfferPro.title}
        </Styles.Title>

        <Styles.Text>
          {studioLocale.bannerOfferPro.description}
        </Styles.Text>

        <Styles.WrapperButton>
          <GradientButton
            testId="upgrade-to-pro-button"
            label={studioLocale.bannerOfferPro.buttonLabel}
            onClick={() => handleShowModalGetPro && handleShowModalGetPro()}
            variant="primary"
            width={mobile ? 'full' : 'fit'}
          />
        </Styles.WrapperButton>
      </Styles.WrapperText>
      <Styles.WrapperImage />
    </Styles.BannerOfferPro>
  );
};

export default withErrorBoundary(BannerOfferPro, 'BannerOfferPro');
